// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h2{\n    color:rgb(152,0,0)\n}\n/* .CGSA_intro p{\n    display: none;\n}\n.CGSA_intro p.active{\n    display: block;\n} */", "",{"version":3,"sources":["webpack://src/components/about_us/page.css"],"names":[],"mappings":"AAAA;IACI;AACJ;AACA;;;;;GAKG","sourcesContent":["h2{\n    color:rgb(152,0,0)\n}\n/* .CGSA_intro p{\n    display: none;\n}\n.CGSA_intro p.active{\n    display: block;\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
